<template>
  <div>
    <div class="table-wrapper">
      <table class="list-table">
        <thead>
          <tr>
            <th>{{ $t("trading.table.symbol") }}</th>
            <th>{{ $t("trading.table.size") }}</th>
            <th>{{ $t("trading.table.entryPrice") }}</th>
            <th>{{ $t("trading.table.liqPrice") }}</th>
            <th>{{ $t("trading.table.margin") }}</th>
            <th>PNL</th>
            <th class="txt-gold" colspan="1" @click="closeAllPosition">
              {{ $t("trading.table.closePosition") }}
            </th>
            <th v-if="rows.length > 0">
              {{ $t("trading.table.price") }} / {{ $t("trading.table.amount") }}
            </th>
            <th>{{ $t("trading.table.tpslPos") }}</th>
          </tr>
        </thead>
        <tbody v-if="rows.length > 0">
          <tr v-for="(row, rowIndex) in rows" :key="row.id || rowIndex">
            <td :class="row.side === 'buy' ? 'plus' : 'minus'">
              <div>
                <p @click="changeChart(row.symbol)">{{ row.symbol }}/USDT</p>
                <div class="symbol-info">
                  <span>Perp</span>
                  <span>{{ row.leverage }}x</span>
                </div>
              </div>
            </td>
            <td :class="row.side === 'buy' ? 'txt-plus' : 'txt-minus'">
              {{ formatNumberWithComma(row.amount) }}
            </td>
            <td>{{ formatNumberWithComma(row.entry_price) }}</td>
            <td class="txt-orange">
              {{
                Number(row.liq_price) !== 0
                  ? formatNumberWithComma(row.liq_price)
                  : "--"
              }}
            </td>
            <td>
              {{ formatNumberWithComma(row.margin) }}USDT <br />
              ({{ row.margin_type }})
            </td>
            <td
              :class="setPnlClass(row.position_id)"
              v-html="setPnlData(row.position_id)"
            ></td>
            <td>
              <div class="btn-area">
                <button
                  class="txt-gold"
                  @click="handleOrder('market', row, rowIndex)"
                >
                  {{ $t("trading.table.market") }}
                </button>
                <button
                  class="txt-gold"
                  @click="handleOrder('limit', row, rowIndex)"
                >
                  {{ $t("trading.table.limit") }}
                </button>
              </div>
            </td>
            <td>
              <div class="input-area">
                <input
                  type="text"
                  :ref="(el) => setPriceInputRef(el, rowIndex)"
                  @input="priceInputHandler($event, row, rowIndex)"
                  @blur="priceInputHandler($event, row, rowIndex)"
                />
                <input
                  type="text"
                  :value="inputValues[rowIndex]"
                  @focus="openPopup($event, row, rowIndex)"
                  @input="
                    (e) => qtyInputHandler(e, row.origin_amount, rowIndex)
                  "
                  :ref="(el) => setInputRef(el, rowIndex)"
                />
              </div>
            </td>
            <td>
              <div class="tpsl-pos">
                <p>{{ row.tpsl }}</p>
                <button class="edit-btn" @click="openTpsl(row)">
                  <img :src="EditIcon" alt="edit icon" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <NodataView v-if="rows.length === 0" height="190px" />
    </div>
    <!-- <div class="" v-else>
      <div class="btns">
        <div class="input-box">
          <input
            class="checkbox"
            type="checkbox"
            id="hideSymbol"
            v-model="hideOtherSymbol"
          />
          <label for="hideSymbol"></label>
          <span>{{ $t("trading.table.hideSymbol") }}</span>
        </div>
        <button>{{ $t("trading.table.closePosition") }}</button>
      </div>
      <div class="gray-line"></div>
      <div
        class="row-wrapper"
        v-for="(row, rowIndex) in rows"
        :key="row.id || rowIndex"
      >
        <div class="symbol sub">
          <p @click="changeChart(row.symbol)">{{ row.symbol }}USDT</p>
          <span class="perp">Perp</span>
          <span class="perp"
            >{{ marginTypeFormatter(row.margin_type) }}
            {{ row.leverage }}x</span
          >
        </div>
        <div class="coin-info">
          <p>{{ $t("trading.table.size") }} (USDT)</p>
          <span :class="row.side === 'buy' ? 'txt-plus' : 'txt-minus'">{{
            formatNumberWithComma(row.size)
          }}</span>
        </div>
        <div class="coin-info">
          <p>{{ $t("trading.table.margin") }} (USDT)</p>
          <span>{{ formatNumberWithComma(row.margin) }}</span>
        </div>
        <div class="coin-info">
          <p>{{ $t("trading.table.entryPrice") }} (USDT)</p>
          <span>{{ formatNumberWithComma(row.entry_price) }}</span>
        </div>
        <div class="coin-info">
          <p>{{ $t("trading.table.liqPrice") }} (USDT)</p>
          <span>{{
            Number(row.liq_price) !== 0
              ? formatNumberWithComma(row.liq_price)
              : "--"
          }}</span>
        </div>
        <div class="coin-info tpsl">
          <p>TP/SL (USDT)</p>
          <span>{{ row.tpsl }}</span>
          <button class="edit-btn" @click="openTpsl(row)">
            <img :src="EditIcon" alt="edit icon" />
          </button>
        </div>
        <div class="coin-info">
          <p>PNL</p>
          <span
            :class="setPnlClass(row.position_id)"
            v-html="setPnlData(row.position_id)"
          ></span>
        </div>
        <div class="tpsl-btns">
          <button @click="openTpsl(row)">TP/SL</button>
          <button @click="handleOrderClose(row.position_id)">
            {{ $t("trading.common.close") }}
          </button>
        </div>
        <div class="gray-line"></div>
      </div>
      <NodataView v-if="rows.length === 0" height="300px" />
    </div> -->
    <Teleport to="body">
      <div
        v-if="showPercentPopup"
        class="percent-popup"
        :style="{
          top: popupPosition.top + 'px',
          left: popupPosition.left + 'px',
        }"
      >
        <button @click="selectPercent(0)">0%</button>
        <button @click="selectPercent(25)">25%</button>
        <button @click="selectPercent(50)">50%</button>
        <button @click="selectPercent(75)">75%</button>
        <button @click="selectPercent(100)">100%</button>
      </div>
    </Teleport>
  </div>
  <ModalTpsl
    :isVisible="tpslPopup"
    :tpslInfo="selectTpslInfo"
    @closeDialogHandler="tpslPopup = false"
    @reloadTpslInfo="reloadTpslInfo"
  />
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :title="alertDialog.title"
    :content="alertDialog.content"
    @closeDialogHandler="alertDialog.isVisible = false"
    :is-btn="true"
  />
</template>

<script setup>
import NodataView from "@/components/common/noData/NodataView.vue";
import ModalTpsl from "@/components/trading/modal/ModalTpsl.vue";
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import {
  amountFormatter,
  formatNumberWithComma,
  inputBlurNumCheck,
  inputNumCheck,
  formatDecimal,
} from "@/utils/order";
import { selectedSymbolData } from "@/utils/symbol";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import { marginTypeFormatter } from "@/utils/formatter";
import { useI18n } from "vue-i18n";
import EditIcon from "@/assets/images/icons/edit_icon.svg";
const { t } = useI18n();
const store = useStore();
const inputRefs = ref([]);
const priceRefs = ref([]);
const inputValues = ref([]);
const selectPercentInfo = ref({ amount: 0, symbol: "", inputIndex: 0 });
const selectTpslInfo = ref({});
const showPercentPopup = ref(false);
const tpslPopup = ref(false);
const alertDialog = ref({
  isVisible: false,
  title: "",
  content: "",
});
const popupPosition = ref({ top: 0, left: 0 });
const isDarkMode = computed(() => store.getters["displayed/isDarkMode"]);
const userNo = computed(() => store.state.account.userNo);
const isMobile = computed(() => store.state.account.isMobile);
const isBitget = computed(() => store.state.transact.isBitget);
const sizeType = computed(() => store.state.transact.sizeType);
const allSymbol = computed(() => store.state.transact.allSymbolData);
const reCode = computed(() => store.state.transact.reCode);
const historyReCode = computed(() => store.state.user_history.reCode);
const positionPnlList = computed(
  () => store.state.user_history.positionPnlList,
);
const positionList = computed(() => {
  const list = store.state.user_history.positionList;
  const symbol = store.state.transact.ticker;
  return store.state.user_history.hideOtherSymbol
    ? list.filter((v) => v.symbol === symbol)
    : list;
});
const hideOtherSymbol = computed({
  get: () => store.state.user_history.hideOtherSymbol,
  set: (value) => store.commit("user_history/setHideOtherSymbol", value),
});
const rows = computed(() => {
  return positionList.value.map((v) => {
    const tp = v.tp === "0.0" ? "--" : v.tp;
    const sl = v.sl === "0.0" ? "--" : v.sl;
    return {
      ...v,
      time: v.datetime,
      amount: amountFormatter(
        sizeType.value === "USDT" ? v.size : v.amount,
        v.symbol,
      ),
      origin_amount: amountFormatter(v.amount, v.symbol, true),
      tpsl: `${tp} / ${sl}`,
    };
  });
});

const setInputRef = (el, index) => {
  nextTick(() => {
    if (el) inputRefs.value[index] = el;
  });
};
const setPnlData = (id) => {
  const data = positionPnlList.value?.find((v) => v.pos_id === id);
  if (data) {
    const formattedData = formatDecimal(data.pnl, 4);
    const formattedPercent = formatDecimal(data.roi_pct, 2);
    if (formattedData.charAt(0) != "-")
      return `+${formattedData}USDT <br /> (+${formattedPercent}%)`;
    return `${formattedData}USDT <br /> (${formattedPercent}%)`;
  } else {
    return "-";
  }
};
const setPnlClass = (id) => {
  const data = positionPnlList.value?.find((v) => v.pos_id === id);
  let classname;
  if (data) {
    if (data.pnl > 0) classname = "txt-plus";
    else if (data.pnl < 0) classname = "txt-minus";
    return classname;
  }
};

const setPriceInputRef = (el, index) => {
  nextTick(() => {
    if (el) priceRefs.value[index] = el;
  });
};

const handleError = async (reCode, isOrder) => {
  if (reCode !== 0) {
    alertDialog.value.isVisible = true;
    alertDialog.value.title = t(`trading.common.error`);
    alertDialog.value.content = t(`trading.error.${reCode.value}`);
  } else {
    alertDialog.value.isVisible = true;
    alertDialog.value.title = t(`trading.common.alert`);
    if (isOrder) {
      alertDialog.value.content = t(`trading.positions.sent10`);
    } else {
      alertDialog.value.content = t(`trading.positions.sent01`);
    }
    await store.dispatch("account/fetchUserWallet");
    await store.dispatch("user_history/fetchAllHistory", userNo.value);
  }
};

const openPopup = (event, row, rowIndex) => {
  selectPercentInfo.value.amount = row.origin_amount;
  selectPercentInfo.value.symbol = row.symbol;
  selectPercentInfo.value.inputIndex = rowIndex;
  const rect = event.target.getBoundingClientRect();
  popupPosition.value = {
    top: rect.bottom + window.scrollY + 4,
    left: rect.left + window.scrollX,
  };
  showPercentPopup.value = true;
};

const selectPercent = (percent) => {
  const baseAmount = parseFloat(selectPercentInfo.value.amount || 0);
  const calculatedAmount = (baseAmount * percent) / 100;
  const formatted = amountFormatter(
    calculatedAmount,
    selectPercentInfo.value.symbol,
    true,
  );
  const targetInput = inputRefs.value[selectPercentInfo.value.inputIndex];
  if (targetInput) {
    targetInput.value = formatted;
    inputValues.value[selectPercentInfo.value.inputIndex] = formatted;
  }
  showPercentPopup.value = false;
};

const qtyInputHandler = (e, amount, index) => {
  const inputValue = e.target.value;
  const symbolData = allSymbol.value.find(
    (s) => s.symbol === `${selectPercentInfo.value.symbol}USDT`,
  );
  if (!symbolData) return;
  const quantityPrecision = isBitget.value
    ? Number(symbolData.volumePlace)
    : symbolData.quantityPrecision;

  let formattedQty = inputNumCheck(inputValue, quantityPrecision);
  let val =
    Number(formattedQty) < 0
      ? 0
      : Number(formattedQty) > amount
      ? amount
      : formattedQty;
  e.target.value = val;
  inputValues.value[index] = val;
};

const priceInputHandler = (e, row, index) => {
  let value = e.target.value;
  const symbolData = selectedSymbolData(row.symbol);
  let formattedPrice;
  if (e.type === "input") {
    formattedPrice = inputNumCheck(value, symbolData.pricePrecision);
  } else {
    formattedPrice = inputBlurNumCheck(value, symbolData, "price");
  }
  e.target.value = formattedPrice;
};

const closeAllPosition = async () => {
  await store.dispatch("user_history/postClosePositionAll", userNo.value);
  handleError(historyReCode.value);
};

const handleClickOutside = (e) => {
  const isPopup = e.target.closest(".percent-popup");
  const isInput = e.target.closest(".input-area input");
  if (!isPopup && !isInput) showPercentPopup.value = false;
};

const handleOrder = async (orderType, row, rowIndex) => {
  const reverseSide = row.side === "buy" ? "sell" : "buy";
  const amount = inputValues.value[rowIndex];
  const price = priceRefs.value[rowIndex].value;
  let orderInfo = {
    type: reverseSide,
    user_no: userNo.value,
    symbol: row.symbol,
    margin_type: row.margin_type === "cross" ? 1 : 0,
    leverage: row.leverage,
    amount: amount,
  };
  if (amount <= 0) {
    alertDialog.value.isVisible = true;
    alertDialog.value.title = null;
    alertDialog.value.content = t(`trading.positions.sent02`);
    return;
  }
  if (orderType === "limit") {
    if (!price) {
      alertDialog.value.isVisible = true;
      alertDialog.value.title = null;
      alertDialog.value.content = t(`trading.positions.sent03`);
      return;
    }
    orderInfo.price = price;
    store.commit("transact/setOrderInfo", orderInfo);
    await store.dispatch("transact/fetchPostLimitOrder");
  } else {
    store.commit("transact/setOrderInfo", orderInfo);
    await store.dispatch("transact/fetchPostMarketOrder");
  }
  handleError(reCode.value, true);
};
const handleOrderClose = async (positionId) => {
  await store.dispatch("user_history/postClosePosition", {
    userNo: userNo.value,
    positionId,
  });
  handleError(historyReCode.value);
};

const openTpsl = (row) => {
  selectTpslInfo.value = { ...row };
  tpslPopup.value = true;
};
const reloadTpslInfo = async () => {
  const info = positionList.value.find(
    (v) => selectTpslInfo.value.position_id === v.position_id,
  );
  selectTpslInfo.value = info;
};

const changeChart = (ticker) => {
  store.commit("transact/setTicker", ticker);
};

watch(
  rows,
  (newRows) => {
    inputValues.value = newRows.map((r) => r.origin_amount.toString());
  },
  { immediate: true },
);

onMounted(() => document.addEventListener("click", handleClickOutside));
onBeforeUnmount(() =>
  document.removeEventListener("click", handleClickOutside),
);
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/common/list.scss" as list;
@use "@/assets/scss/components/trading/history/openOrders.scss" as openOrders;
@use "@/assets/scss/components/trading/history/position.scss" as position;
</style>
